import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-map-popup',
  templateUrl: './stations-map.component.html',
  styleUrls: ['./stations-map.component.css'],
})
export class MapPopupComponent implements OnInit, AfterViewInit {
  @Input() comments: any;
  @Input() baseStation: any;
  @Output() close = new EventEmitter<void>();
  private map!: L.Map;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.initMap();
    this.addMarkers();
    console.log(this.comments, this.baseStation);
  }

  private initMap(): void {
    this.map = L.map('map', {
      center: [-33.7809, 151.1504], // Default center
      zoom: 10,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(this.map);
  }

  private addMarkers(): void {
    const stations = this.comments;

    var myIcon = L.icon({
      iconUrl: 'marker-icon.png',
      iconSize: [25, 41], // Width, height
      iconAnchor: [12, 41], // Adjust to center the icon properly
    });

    var routerIcon = L.divIcon({
      html: '<i class="fa-solid fa-tower-broadcast" style="color: blue; font-size: 30px;"></i>', // Use Font Awesome class
      className: 'fa-icon',
      iconSize: [30, 30],
      iconAnchor: [15, 30],
    });

    const routerMarker = L.marker(
      [this.baseStation.latitude, this.baseStation.longitude],
      { icon: routerIcon }
    ).addTo(this.map);
    routerMarker.bindPopup(
      `<b>Base Station</b><br>Status: ${this.baseStation.status}<br>Height: ${this.baseStation.height}`
    );

    const bounds = L.latLngBounds([
      this.baseStation.latitude,
      this.baseStation.longitude,
    ]);

    for (const station of stations) {
      const marker = L.marker([station.latitude, station.longitude], {
        icon: myIcon,
      }).addTo(this.map);
      marker.bindPopup(
        `<b>${station.name}</b><br>Type: ${station.type}<br>Status: ${station.status}`
      );

      // Extend the bounds to include each station
      bounds.extend([station.latitude, station.longitude]);

      // Draw a dotted line between the router and the station
      const polyline = L.polyline(
        [
          [this.baseStation.latitude, this.baseStation.longitude],
          [station.latitude, station.longitude],
        ],
        {
          color: 'blue',
          weight: 2,
          opacity: 0.5,
          dashArray: '5, 10',
        }
      ).addTo(this.map);

      // Calculate distance between points
      const distance = this.map.distance(
        [this.baseStation.latitude, this.baseStation.longitude],
        [station.latitude, station.longitude]
      );

      // Create a label for the distance
      const midPoint = [
        (this.baseStation.latitude + station.latitude) / 2,
        (this.baseStation.longitude + station.longitude) / 2,
      ];

      const angle =
        Math.atan2(
          station.latitude - this.baseStation.latitude,
          station.longitude - this.baseStation.longitude
        ) *
        (180 / Math.PI) - 90;

      const distanceLabel = L.divIcon({
        html: `<div style="background: white; padding: 2px; border-radius: 3px; text-align: center; transform: rotate(${angle}deg);">${(
          distance / 1000
        ).toFixed(2)} km</div>`,
        className: 'distance-label',
        iconSize: [100, 40],
        iconAnchor: [50, 20],
      });

      const distanceMarker = L.marker(midPoint as [number, number], {
        icon: distanceLabel,
      }).addTo(this.map);

      // Show distance label only when zoomed to a certain level
      this.map.on('zoomend', () => {
        if (this.map.getZoom() >= 13) {
          distanceMarker.setOpacity(1);
        } else {
          distanceMarker.setOpacity(0);
        }
      });
    }

    // Fit the map to the bounds of the markers
    this.map.fitBounds(bounds);
  }
}
